export enum PassportGroupActionsEnum {
  PASSPORT_GROUP_CREATE = 'PASSPORT_GROUP_CREATE',
  PASSPORT_GROUP_GET_PAGE = 'PASSPORT_GROUP_GET_PAGE',
  PASSPORT_GROUP_GET_NEXT_PAGE = 'PASSPORT_GROUP_GET_NEXT_PAGE',
  PASSPORT_GROUP_SET_LIST = 'PASSPORT_GROUP_SET_LIST',
  PASSPORT_GROUP_SET_TOTAL_COUNT = 'PASSPORT_GROUP_SET_TOTAL_COUNT',
  PASSPORT_GROUP_SET_CURRENT_PAGE = 'PASSPORT_GROUP_SET_CURRENT_PAGE',
  PASSPORT_GROUP_PASSPORT_GET_PAGE = 'PASSPORT_GROUP_PASSPORT_GET_PAGE',
  PASSPORT_GROUP_PASSPORT_GET_NEXT_PAGE = 'PASSPORT_GROUP_PASSPORT_GET_NEXT_PAGE',
  PASSPORT_GROUP_PASSPORT_SET_LIST = 'PASSPORT_GROUP_PASSPORT_SET_LIST',
  PASSPORT_GROUP_PASSPORT_SET_TOTAL_COUNT = 'PASSPORT_GROUP_PASSPORT_SET_TOTAL_COUNT',
  PASSPORT_GROUP_PASSPORT_SET_CURRENT_PAGE = 'PASSPORT_GROUP_PASSPORT_SET_CURRENT_PAGE',
  PASSPORT_GROUP_GET = 'PASSPORT_GROUP_GET',
  PASSPORT_GROUP_SET = 'PASSPORT_GROUP_SET',
  PASSPORT_GROUP_APPLY = 'PASSPORT_GROUP_APPLY',
  PASSPORT_GROUP_APPLY_BY_KNO = 'PASSPORT_GROUP_APPLY_BY_KNO',
  PASSPORT_GROUP_SET_APPLY_SUCCESS = 'PASSPORT_GROUP_SET_APPLY_SUCCESS',
  PASSPORT_GROUP_SET_CREATE_SUCCESS = 'PASSPORT_GROUP_SET_CREATE_SUCCESS',
  PASSPORT_GROUP_SET_NOTICE = 'PASSPORT_GROUP_SET_NOTICE',
  PASSPORT_GROUP_GET_RISK_INDICATORS_SELECT_OPTIONS = 'PASSPORT_GROUP_GET_RISK_INDICATORS_SELECT_OPTIONS',
  PASSPORT_GROUP_INIT_DETAIL_FORM = 'PASSPORT_GROUP_INIT_DETAIL_FORM',
  PASSPORT_GROUP_SET_INIT_FORM = 'PASSPORT_GROUP_SET_INIT_FORM',
  PASSPORT_GROUP_PASSPORT_APPLY_BY_KNO = 'PASSPORT_GROUP_PASSPORT_APPLY_BY_KNO',
  PASSPORT_GROUP_GET_IS_EXISTS_GROUPS_FOR_CANCELLATION = 'PASSPORT_GROUP_GET_IS_EXISTS_GROUPS_FOR_CANCELLATION',
  PASSPORT_GROUP_SET_IS_EXISTS_GROUPS_FOR_CANCELLATION = 'PASSPORT_GROUP_SET_IS_EXISTS_GROUPS_FOR_CANCELLATION',
  PASSPORT_GROUP_EXPORT = 'PASSPORT_GROUP_EXPORT',
  PASSPORT_GROUP_DELETE = 'PASSPORT_GROUP_DELETE',
  PASSPORT_GROUP_SET_IS_DELETED = 'PASSPORT_GROUP_SET_IS_DELETED',
  PASSPORT_GROUP_EXCLUDE_PASSPORTS = 'PASSPORT_GROUP_EXCLUDE_PASSPORTS',
}
